export default __webpack_public_path__ + "static/media/236-republic-of-macedonia.fff4c119.svg";